import z from 'zod';

export const passwordCopy = {
    empty: 'Enter password. Must be at least 8 characters with one number and one special character',
    complexity: 'Must be at least 8 characters with one number and one special character',
} as const;

const hasNumber = /[0-9]/;
const hasSpecial = /[^A-Za-z0-9]/;

export const passwordSchema = z
    .string()
    .min(1, passwordCopy.empty)
    .min(8, passwordCopy.complexity)
    .refine((value) => hasNumber.test(value), passwordCopy.complexity)
    .refine((value) => hasSpecial.test(value), passwordCopy.complexity);
